import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fade, Bounce } from "react-awesome-reveal";
import {
  faComputer,
  faCreditCard,
  faEarth,
  faEarthAfrica,
  faFlag,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";
import "./index.scss";

const SectionCounter = () => {
  return (
    <>
      <div className="section-counter">
        <div className="header" align="center">
          <Bounce cascade>
            <h1 className="title-text">We are trusted by:</h1>
          </Bounce>
        </div>
        <div className="counter" align="center">
          <div className="w3-container counter-content">
            <div className="w3-row">
              <div className="w3-third">
                <Fade direction="right" delay={200}>
                  <div className="counter-item">
                    <div className="circle">
                      <FontAwesomeIcon icon={faEarthAfrica} className="icons" />
                    </div>
                    <br />
                    <span className="item-number">800</span>
                    <br />
                    <span className="item-text">
                      schools use Mygradecard across Africa
                    </span>
                  </div>
                </Fade>
              </div>
              <div className="w3-third">
                <Fade direction="right" delay={200}>
                  <div className="counter-item">
                    <div className="circle">
                      <FontAwesomeIcon icon={faFlag} className="icons" />
                    </div>
                    <br />
                    <span className="item-number">36</span>
                    <br />
                    <span className="item-text">State puls FCT</span>
                  </div>
                </Fade>
              </div>
              <div className="w3-third">
                <Fade direction="right" delay={200}>
                  <div className="counter-item">
                    <div className="circle">
                      <FontAwesomeIcon icon={faComputer} className="icons" />
                    </div>
                    <br />
                    <span className="item-number">12000</span>
                    <br />
                    <span className="item-text">computed result</span>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="w3-row">
              <div className="w3-third">
                <Fade direction="left" delay={200}>
                  <div className="counter-item">
                    <div className="circle">
                      <FontAwesomeIcon icon={faEarth} className="icons" />
                    </div>
                    <br />
                    <span className="item-number">10</span>
                    <br />
                    <span className="item-text">country across the glob </span>
                  </div>
                </Fade>
              </div>
              <div className="w3-third">
                <Fade direction="left" delay={200}>
                  <div className="counter-item">
                    <div className="circle">
                      <FontAwesomeIcon
                        icon={faGraduationCap}
                        className="icons"
                      />
                    </div>
                    <br />
                    <span className="item-number">12000000</span>
                    <br />
                    <span className="item-text">result printed to student</span>
                  </div>
                </Fade>
              </div>
              <div className="w3-third">
                <Fade direction="left" delay={200}>
                  <div className="counter-item">
                    <div className="circle">
                      <FontAwesomeIcon icon={faCreditCard} className="icons" />
                    </div>
                    <br />
                    <span className="item-number">430000</span>
                    <br />
                    <span className="item-text">payment is made easier </span>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionCounter;
